import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import type { AutosRelifCar } from 'services/api/autosrelif.api';

const DEFAULT_IMAGE = 'https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?w=400';
const BACKGROUND_COLOR = '#f7fafc';

const SpecItem = ({ label, value }: { label: string; value: string }) => (
  <Box sx={{ background: BACKGROUND_COLOR, p: 2, borderRadius: 2 }}>
    <Typography
      sx={{
        fontSize: 13,
        color: 'text.secondary',
        fontWeight: 600,
      }}
    >
      {label}
    </Typography>
    <Typography
      sx={{
        fontSize: 18,
        fontWeight: 500,
      }}
    >
      {value}
    </Typography>
  </Box>
);

type Props = {
  car: AutosRelifCar;
  onClose: () => void;
};

const AutosRelifDetailSection = ({ car, onClose }: Props) => {
  const title = `${car.brand} ${car.model}`;
  const price = car.price ? `$${car.price.toLocaleString('es-CL')}` : 'Consultar precio';

  return (
    <Box sx={{ background: BACKGROUND_COLOR, py: 6 }}>
      <Box
        sx={{
          maxWidth: '1200px',
          mx: 'auto',
          px: 3,
        }}
      >
        <Button onClick={onClose} sx={{ mb: 3 }}>
          ← Volver al listado
        </Button>

        <Box
          sx={{
            background: '#fff',
            borderRadius: 3,
            p: 4,
            boxShadow: 3,
          }}
        >
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
              gap: 4,
            }}
          >
            <img
              src={car.image || DEFAULT_IMAGE}
              alt={title}
              style={{
                width: '100%',
                maxHeight: 400,
                objectFit: 'contain',
                borderRadius: 12,
              }}
            />

            <Box>
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 700,
                }}
              >
                {title}
              </Typography>

              {car.version && (
                <Typography
                  sx={{
                    color: 'text.secondary',
                  }}
                >
                  {car.version}
                </Typography>
              )}

              {car.year && (
                <Typography
                  sx={{
                    color: 'text.secondary',
                  }}
                >
                  Año: {car.year}
                </Typography>
              )}

              <Typography
                variant="h5"
                sx={{
                  fontWeight: 700,
                  mt: 3,
                }}
              >
                {price}
              </Typography>

              <Button
                sx={{ mt: 4 }}
                variant="contained"
                color="success"
                href={`https://wa.me/56993057973?text=Hola,%20quiero%20más%20info%20sobre%20${encodeURIComponent(
                  title
                )}`}
                target="_blank"
              >
                Contactar por WhatsApp
              </Button>
            </Box>
          </Box>

          <Box
            sx={{
              mt: 4,
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
              gap: 2,
            }}
          >
            {car.km && <SpecItem label="Kilometraje" value={`${car.km} km`} />}
            {car.transmission && <SpecItem label="Transmisión" value={car.transmission} />}
            {car.fuelType && <SpecItem label="Combustible" value={car.fuelType} />}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default AutosRelifDetailSection;
